import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ScamReportsTable from "./ScamReportsTable";
import { ScammerForm } from "./ScammerForm";
import { Helmet } from "react-helmet-async";
import { VideoThumbnails } from "../VideoThumbnails";
import smart_plus_videos from '../preloaded/smart_plus_videos.json'
import resources from "../../lang/resources";
import { hasReportedAlready } from "../requests/getReports";

export const DecodingPonzi = () => {
  const { t } = useTranslation();
  const [hasRecords, setHasRecords] = useState(false);

  useEffect(() => {
    (async () => {
      setHasRecords(await hasReportedAlready());
    })();
  }, []);

  // Create a ref to reference the child component
  const childRef = useRef(null);

  const handleSubmit = async (formData) => {
    console.log('Form Data Submitted:', formData);
    // Call the child's function using the ref
    if (childRef.current) {
      childRef.current.childFunction();
      setHasRecords(await hasReportedAlready());
    }
  };

  const availablesLanguages = ["x-default", ...Object.keys(resources)];

  return (
    <>
      <Helmet>
        <title>Coinnekt {t('scam')} | CNKT | SmartPlus</title>
        <link rel="canonical" href={`https://ponzilover.com/es/smartplus`} />
        {availablesLanguages
          .map((lang) => {
            return (
              <link
                key={lang}
                rel="alternate"
                hrefLang={lang}
                href={lang === "x-default" ? `https://ponzilover.com/es/smartplus` : `https://ponzilover.com/${lang}/smartplus`}
              />
            );
          })
        }
        <meta name="keywords" content={t('smart_keyword')} />
        <meta name="description" content={t('smart_description')} />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={`SmartPlus: ${t('title_ponzi')}`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
      </Helmet>

      <VideoThumbnails videos={smart_plus_videos} />
      <h1 className="text-2xl font-bold mb-4">{t("decoded_ponzi")}: SmartPlus</h1>

      {!hasRecords &&
        <>
          <h2 className="text-xl font-bold mt-6">{t('form_report')}</h2>
          <p className="py-4">
            {t('decoded_ponzi_info')}
          </p>
          <ScammerForm onSubmit={handleSubmit} />
        </>
      }

      <br />
      <hr />
      <ScamReportsTable ref={childRef} />
    </>
  );
};
